'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _overlay = require('../overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _themeable = require('../themeable');

var _themeable2 = _interopRequireDefault(_themeable);

var _portal = require('../portal');

var _portal2 = _interopRequireDefault(_portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var displayName = 'Modal';

var propTypes = {
  /** Header text */
  header: _propTypes2.default.node,
  /** The Modal's children */
  children: _propTypes2.default.node.isRequired,
  /** The Modal's actions */
  actions: _propTypes2.default.node.isRequired,
  /** Override the style of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the style of the content element */
  contentStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the style of the footer element */
  footerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Toggle the Dialogs visibility */
  open: _propTypes2.default.bool,
  /** Override the styles of the overlay element */
  overlayStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  header: null,
  style: {},
  headerStyle: {},
  contentStyle: {},
  footerStyle: {},
  open: false,
  overlayStyle: {}
};

/** A dialog that can only be closed by selecting one of the actions. */
var Modal = function Modal(_ref) {
  var header = _ref.header,
      children = _ref.children,
      actions = _ref.actions,
      style = _ref.style,
      headerStyle = _ref.headerStyle,
      contentStyle = _ref.contentStyle,
      footerStyle = _ref.footerStyle,
      open = _ref.open,
      overlayStyle = _ref.overlayStyle,
      color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['header', 'children', 'actions', 'style', 'headerStyle', 'contentStyle', 'footerStyle', 'open', 'overlayStyle', 'color']);

  if (!open) {
    return null;
  }

  return _react2.default.createElement(
    _portal2.default,
    null,
    _react2.default.createElement(
      _overlay2.default,
      { style: overlayStyle },
      _react2.default.createElement(
        'section',
        _extends({ style: _getStyles2.default.root(style) }, custom),
        _react2.default.createElement(
          'section',
          { style: _getStyles2.default.content(contentStyle) },
          header ? _react2.default.createElement(
            'h1',
            { style: _getStyles2.default.header(headerStyle) },
            header
          ) : null,
          children
        ),
        _react2.default.createElement(
          'footer',
          { style: _getStyles2.default.footer(color, footerStyle) },
          actions
        )
      )
    )
  );
};

Modal.displayName = displayName;
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

var enhance = (0, _compose2.default)((0, _themeable2.default)(), _radium2.default);

exports.default = enhance(Modal);
module.exports = exports.default;